/** Unified RF analysis grid — recommendations, metrics, and heatmap use the same resolution. */
export const RF_GRID_COLS = 48
export const RF_GRID_ROWS = 30
